export const JOBFEED_ACTION_SRC = {
  ABOVE_50: 'JobfeedPage',
  RANGE_31_50: 'JobfeedPage_31-50',
  RANGE_11_30: 'JobfeedPage_11-30',
  RANGE_1_10: 'JobfeedPage_1-10',
  NO_JOBS: 'JobfeedPage_NoJobs',
} as const;

export type JobfeedActionSrc =
  (typeof JOBFEED_ACTION_SRC)[keyof typeof JOBFEED_ACTION_SRC];

export const JOBFEED_ACTION_SRC_BUCKETS: ReadonlyArray<{
  maxJobs: number;
  actionSrc: JobfeedActionSrc;
}> = [
  {maxJobs: 0, actionSrc: JOBFEED_ACTION_SRC.NO_JOBS},
  {maxJobs: 10, actionSrc: JOBFEED_ACTION_SRC.RANGE_1_10},
  {maxJobs: 30, actionSrc: JOBFEED_ACTION_SRC.RANGE_11_30},
  {maxJobs: 50, actionSrc: JOBFEED_ACTION_SRC.RANGE_31_50},
];

export const getJobfeedActionSrc = (
  jobCount?: number | null
): JobfeedActionSrc => {
  const count =
    typeof jobCount === 'number' && Number.isFinite(jobCount) ? jobCount : 0;

  const bucket = JOBFEED_ACTION_SRC_BUCKETS.find(
    ({maxJobs}) => count <= maxJobs
  );

  return bucket?.actionSrc ?? JOBFEED_ACTION_SRC.ABOVE_50;
};
